// extracted by mini-css-extract-plugin
module.exports = {"bg":"#4a4a4a","textColor":"#f7fbfc","primary":"#80c41b","highlight":"#adb846","cloudband1":"#7491b7","cloudband2":"#7491b7"};